import { useState, useEffect } from 'react'

import { Button, Card, Row, Col, Switch } from 'antd'
import { PlusOutlined } from '@ant-design/icons'

import Fade from '@/components/Fade'
import { isEmpty } from 'lodash'

import './ProductionStatus.style.less'
import ModalProductionStatus from './components/ModalProductionStatus/ModalProductionStatus'
import ContentComponent from './components/ContentComponent/ContentComponent'

interface PermissionProps {
  canRead: boolean
  canWrite: boolean
}

interface OrderDetailProps {
  orderQuantity: string
  toBeDeliveredDate: Date
}
interface Props {
  data: any
  permission: PermissionProps
  orderDetail?: OrderDetailProps
}

function ProductionStatus(props: Props) {
  const { data, permission, orderDetail } = props
  const [visibleModal, setVisibleModal] = useState(false)
  const [dateData, setDateData] = useState(data)
  const [tableChartTab, setTableChartTab] = useState<boolean>(false)
  const [firstCreated, setFirstCreated] = useState(false)
  const [disableSwitch, setDisableSwitch] = useState(false)

  const isEmptyData = isEmpty(dateData)
  useEffect(() => {
    setFirstCreated(false)
  }, [])

  function CreateProductionStatus() {
    return (
      <div className="create-pro-status-container">
        <p className="label">Create a Production Status</p>
        <Button
          type="primary"
          size="large"
          onClick={() => {
            setVisibleModal(true)
          }}
        >
          <PlusOutlined />
          Set Plan
        </Button>

        <ModalProductionStatus
          visible={visibleModal}
          onSetPlan={(dateData) => {
            if (!isEmpty(dateData)) {
              setDateData(dateData)
              setVisibleModal(false)
              setFirstCreated(true)
            }
          }}
          orderQuantity={orderDetail?.orderQuantity}
          toBeDeliveredDate={orderDetail?.toBeDeliveredDate}
          onClose={() => {
            setVisibleModal(false)
          }}
        />
      </div>
    )
  }

  const handleDisableTap = (value) => {
    setDisableSwitch(value)
  }

  function HeaderNavigationSection() {
    return (
      <Row className="header-navigation-container">
        <Col span={24} className="ian-name summary-switch text-right">
          <Switch
            disabled={disableSwitch}
            checkedChildren="Table"
            unCheckedChildren="Chart"
            checked={tableChartTab}
            size="default"
            onChange={(value) => {
              setTableChartTab(value)
            }}
          />
        </Col>
      </Row>
    )
  }

  if (permission.canWrite === false && permission.canRead === false) {
    return null
  }

  return (
    <Fade>
      <div className="production-status-container">
        {isEmptyData && permission.canWrite && <CreateProductionStatus />}
      </div>
      {!isEmptyData && (
        <Card className="card">
          <HeaderNavigationSection />
          <ContentComponent
            handleDisableTap={handleDisableTap}
            tableChartTab={tableChartTab ? 'Chart' : 'Table'}
            dataPlannedDate={dateData}
            firstCreated={firstCreated}
            permission={permission}
          />
        </Card>
      )}
    </Fade>
  )
}

export default ProductionStatus
